import React from 'react';
import { Box } from '@zillow/constellation';

/**
 * Renders a menu list with specified styling.
 *
 * @param {ReactNode} children - The children elements to be rendered within the menu list.
 * @param {object} sx - Additional styling properties for the menu list.
 * @return {JSX.Element} The rendered menu list component.
 */
var MenuList = function MenuList(_ref) {
  var children = _ref.children,
    sx = _ref.sx;
  return /*#__PURE__*/React.createElement(Box, {
    as: "ul",
    sx: Object.assign({
      alignItems: 'end',
      listStyle: 'none',
      padding: '$spacing.none',
      margin: '$spacing.none'
    }, sx)
  }, children);
};
var MenuList$1 = MenuList;

export { MenuList$1 as default };
